export default __webpack_public_path__ + "static/media/transaction.dec90eac.svg";